import { Platform } from 'react-native';

const SHARE_TOKEN_PATTERN = /^[a-f0-9]{64}$/i;

const extractTokenFromPath = (pathname: string): string | null => {
  const match = pathname.match(/\/share\/([^/?#]+)/i);
  const token = match?.[1]?.trim();

  if (!token || !SHARE_TOKEN_PATTERN.test(token)) {
    return null;
  }

  return token;
};

export const isValidShareToken = (token: string): boolean => SHARE_TOKEN_PATTERN.test(token.trim());

export const parseShareTokenFromUrl = (url: string): string | null => {
  if (!url) {
    return null;
  }

  if (url.includes('lifecycle://')) {
    const rawPath = url.split('://')[1]?.split('?')[0] ?? '';
    const normalizedPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
    return extractTokenFromPath(normalizedPath);
  }

  try {
    const parsedUrl = new URL(url, Platform.OS === 'web' ? window.location.origin : 'https://app.local');
    return extractTokenFromPath(parsedUrl.pathname);
  } catch {
    return extractTokenFromPath(url.startsWith('/') ? url : `/${url}`);
  }
};

export const getInitialShareToken = (): string | null => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    return parseShareTokenFromUrl(window.location.href);
  }

  return null;
};
